export default "__VITE_ASSET__d3416a12__"